/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartUseCasesAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 7.5a4.502 4.502 0 0 1 3.5-4.388V8.5h5.388A4.502 4.502 0 0 1 12 7.5zM16.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM4 8v13H1v2h18v-2h-3v-4h-2v4h-3v-7H9v7H6V8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartUseCasesAlt as ChartUseCasesAlt };
